module.exports = __webpack_public_path__ + "static/utomi-ecc8a01244698073cc15ca2380b7fd7c.png";